import { CompanyEntryDto } from "@advanced-sales-technologies/backend-client/models/CompanyEntryDto";
import { ColumnDef } from "@tanstack/react-table";
import { HiOutlineEnvelope } from "react-icons/hi2";

import BaseColumn from "@/components/molecules/table/BaseColumn";
import HasMoreOfficeEmailCell from "@/components/molecules/table/search/columns/HasMoreOfficeEmailCell";
import { searchColumns, SearchColumnsProps } from "@/components/organisms/search/searchColumns";

const hqEmailColumn = ({ t, listId, searchParams, queryKey }: SearchColumnsProps): ColumnDef<CompanyEntryDto> =>
  BaseColumn<CompanyEntryDto>({
    accessorFn: (row) => row.office_hq?.contact_info?.email?.value,
    id: searchColumns(t).hq_email.id,
    header: () => searchColumns(t).hq_email.name,
    cell: (info) => (
      <HasMoreOfficeEmailCell
        info={info}
        officeKey={"office_hq"}
        t={t}
        queryKey={queryKey}
        listId={listId}
        searchParams={searchParams}
      />
    ),
    meta: {
      heading: {
        icon: HiOutlineEnvelope,
        className: "!bg-var-warning-50 hover:!bg-var-warning-100 active:!bg-var-warning-200",
      },
      column: {
        className: "bg-var-warning-25",
      },
    },
  });

export default hqEmailColumn;
